import React from 'react'
import { Button } from '../../lib/components'
import { InvestV2SupportHeadsetIcon } from './invest-v2-icons'

type Props = {
  onContactSupport: () => void
}

const InvestV2SupportBanner = ({ onContactSupport }: Props) => {
  return (
    <section className='invest-v2__support' data-testid='invest-v2-support'>
      <div className='invest-v2__support-inner'>
        <div className='invest-v2__support-avatar' aria-hidden>
          <InvestV2SupportHeadsetIcon />
        </div>
        <div className='invest-v2__support-copy'>
          <p className='invest-v2__support-title'>Need assistance?</p>
          <p className='invest-v2__support-sub'>
            Our client relations team is available 9am – 6pm.
          </p>
        </div>
        <Button
          variant='secondary-btn'
          text='Contact Support'
          handleClick={onContactSupport}
          classes={['invest-v2__support-btn']}
          testId='invest-v2-contact-support'
        />
      </div>
    </section>
  )
}

export { InvestV2SupportBanner }
